import React from 'react';
import PropTypes from 'prop-types';

import { FlexRow } from 'ui-components/components/flex';

import { getLocationStringDefault } from '../../helpers';
import { useAddressFormContext } from '../../context';
import { PhoneLine } from '../../read-only-fields/phone';
import { EmailLink } from '../../read-only-fields/email';
import { AddressLine } from '../../read-only-fields/address-line';
import { Company } from '../../read-only-fields/company';
import { Name } from '../../read-only-fields/name';

export const DefaultFields = ({ style }) => {
  const { address, recipientInfo } = useAddressFormContext();
  const {
    name,
    company = '',
    phone = '',
    line1 = '',
    line2 = '',
    line3 = '',
    city = '',
    state = '',
    postalCode = '',
    countryCode = '',
  } = address;
  const { email } = recipientInfo;
  const defaultLocation = getLocationStringDefault(city, state, postalCode);

  return (
    <div className={style}>
      <Name name={name} />
      <Company company={company} />
      <AddressLine line={line1} />
      <AddressLine line={line2} />
      <AddressLine line={line3} />
      {defaultLocation && <FlexRow>{defaultLocation}</FlexRow>}
      {countryCode && <FlexRow>{countryCode}</FlexRow>}
      <PhoneLine phone={phone} />
      <EmailLink email={email} />
    </div>
  );
};

DefaultFields.propTypes = {
  style: PropTypes.string,
};
